/*
  LINE連携ポップアップの出し方。
  2026-10-05：デッドクリック対策で theme.js の NewsletterPopup（20秒タイマー）をやめ、ここで開閉を決めるようにした。
  2026-10-12（松本様ご指示）：画面いっぱいに自動で開くのをやめ、右下のチャットのアイコンの上に
  小さな「LINE連携で10%OFF」ボタン（sections/newsletter-popup.liquid の .lf-line-badge）を出す。
  Clarity で一覧ページの「閉じる」が多かった（ネックレス一覧で3日に約450回）ため。

    - ボタンはページを開いて少したってから出す。押すと今までの案内（モーダル）を開く。
    - ボタンの × を押した人には、セクション設定「再表示までの日数」のあいだ出さない。
    - 案内の画像・見出し・ボタンを押した人（連携に進んだ人）には365日出さない。
    - ログイン中の会員、商品・カート・会員ページは section 側で描画しないので、ここでは判定しない。

  theme.Modals を使うので、defer の theme.js が実行された後（DOMContentLoaded）に動かす。
*/
(() => {
  const STORE_KEY = 'lf-line-popup';
  const DAY_MS = 864e5;
  const CLICKED_DAYS = 365;
  const BADGE_DELAY_MS = 1500;

  // プライベートブラウズ等で storage が使えなくても、表示判定だけは動くようにする。
  const read = (area, key) => {
    try { return window[area].getItem(key); } catch (e) { return null; }
  };
  const write = (area, key, value) => {
    try { window[area].setItem(key, value); } catch (e) { /* 保存できなくても続行 */ }
  };

  const isSuppressed = () => {
    try {
      const state = JSON.parse(read('localStorage', STORE_KEY) || 'null');
      return Boolean(state && state.until > Date.now());
    } catch (e) {
      return false;
    }
  };

  const suppress = (days, reason) => {
    write('localStorage', STORE_KEY, JSON.stringify({ reason, until: Date.now() + days * DAY_MS }));
  };

  const init = () => {
    const root = document.querySelector('[data-lf-line-popup]');
    const badge = document.querySelector('[data-lf-line-badge]');
    if (!root || !window.theme || typeof theme.Modals !== 'function') return;

    // テーマエディタでの開閉は theme.js の NewsletterPopup（onSelect / onDeselect）に任せる。
    if (window.Shopify && Shopify.designMode) return;

    // theme.js も同じ要素に Modal を作るが、data-test-mode="true" なので自分からは開かない。
    const modal = new theme.Modals(root.id, 'lf-line-popup-modal');
    const closedDays = Number(root.dataset.delayDays) || 5;

    const hideBadge = () => {
      if (!badge) return;
      badge.classList.remove('is-visible');
      window.setTimeout(() => { badge.hidden = true; }, 300);
    };

    root.querySelectorAll('[data-lf-line-popup-link]').forEach((link) => {
      link.addEventListener('click', () => {
        suppress(CLICKED_DAYS, 'clicked');
        hideBadge();
      });
    });

    if (!badge || isSuppressed()) return;

    badge.querySelector('[data-lf-line-badge-open]').addEventListener('click', () => {
      modal.open();
    });

    badge.querySelector('[data-lf-line-badge-close]').addEventListener('click', () => {
      suppress(closedDays, 'closed');
      hideBadge();
    });

    // チャット（Channel Talk）のアイコンを実際に測り、その真上に同じ大きさで置く（松本様 2026-10-13）。
    // アイコンの大きさは端末（スマホ／PC）で決まり、画面幅の CSS だけでは幅の狭いPCの画面などでずれるため。
    // チャットは読み込みが遅いので、見つかるまで30秒ほど待つ。見つからなければ CSS の予備の数値のまま。
    // 画面の高さはスクロールでツールバーが出入りするたびに変わるので、横幅が変わったときだけ測り直す。
    const findLauncher = () => {
      const plugin = document.getElementById('ch-plugin');
      if (!plugin) return null;
      for (const el of plugin.querySelectorAll('*')) {
        const found = el.shadowRoot && el.shadowRoot.querySelector('[class*="LauncherButtonWrapper"]');
        if (found) return found;
      }
      return null;
    };

    const alignToChat = () => {
      const launcher = findLauncher();
      if (!launcher) return false;
      const rect = launcher.getBoundingClientRect();
      if (rect.width < 20) return false;
      const size = Math.round(rect.width);
      const right = Math.round(document.documentElement.clientWidth - rect.right);
      const bottom = Math.round(window.innerHeight - rect.bottom);
      const gap = Math.round(size * 0.22);
      badge.style.setProperty('--lf-chat-size', `${size}px`);
      badge.style.setProperty('--lf-chat-right', `${right}px`);
      badge.style.setProperty('--lf-chat-bottom', `${bottom + size + gap}px`);
      badge.style.setProperty('--lf-chat-radius', `${Math.round(size * 0.42)}px`);
      badge.classList.toggle('lf-line-badge--lg', size >= 50);
      badge.classList.toggle('lf-line-badge--sm', size < 50);
      return true;
    };

    let tries = 0;
    const waitForChat = window.setInterval(() => {
      tries += 1;
      if (alignToChat() || tries >= 60) window.clearInterval(waitForChat);
    }, 500);

    let lastWidth = window.innerWidth;
    window.addEventListener('resize', () => {
      if (window.innerWidth === lastWidth) return;
      lastWidth = window.innerWidth;
      window.setTimeout(alignToChat, 300);
    });

    window.setTimeout(() => {
      badge.hidden = false;
      // 表示してから少しおいてクラスを付け、ふわっと出す（requestAnimationFrame は裏のタブで止まるので使わない）
      window.setTimeout(() => badge.classList.add('is-visible'), 30);
    }, BADGE_DELAY_MS);
  };

  // defer 実行時点の readyState は 'interactive' で、theme.js はまだ実行されていない。
  // DOMContentLoaded は defer スクリプトがすべて終わった後に来るので、そこで初期化する。
  let started = false;
  const start = () => {
    if (started) return;
    started = true;
    init();
  };
  if (document.readyState === 'complete') {
    start();
  } else {
    document.addEventListener('DOMContentLoaded', start);
    window.addEventListener('load', start);
  }
})();
